import { render } from "./AppCoreHeaderRight.vue?vue&type=template&id=99ed64aa"
import script from "./AppCoreHeaderRight.vue?vue&type=script&lang=js"
export * from "./AppCoreHeaderRight.vue?vue&type=script&lang=js"

import exportComponent from "/data/vstsagent02/user/3205/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__